interface NotificationBadgeProps {
  count: number
  className?: string
}

/** Red numeric badge. Renders nothing when count ≤ 0; caps display at '9+'. */
export default function NotificationBadge({ count, className = '' }: NotificationBadgeProps) {
  if (count <= 0) return null
  const label = count > 9 ? '9+' : String(count)
  return (
    <span
      className={`inline-flex min-w-[18px] h-[18px] items-center justify-center rounded-full bg-red-500 px-1 text-[11px] font-semibold leading-none text-white ${className}`}
    >
      {label}
    </span>
  )
}
